import { useLocation } from 'react-router-dom';
import { isNil } from 'lodash-es';
import { parse } from 'query-string';

import { DEFAULT_PER_PAGE_COUNT } from '@/services/constants';
import { UrlSearchParams } from '@/store/segments/types';

export const useRequestParams = (): UrlSearchParams => {
    const location = useLocation();
    const query = parse(location.search, { parseBooleans: true });

    const limit = query?.perPage ? +query.perPage : DEFAULT_PER_PAGE_COUNT;
    const search = isNil(query?.searchName) ? null : (query?.searchName as string);

    return {
        searchName: search,
        page: +query.page || 1,
        perPage: limit,
    };
};
